<template>
<div class="general-info">
  <div class="general-info__container">
    <div class="general-info__row">
      <div v-if="showDynamicMenu" class="floating-menu">
        <DynamicMenu :menu-items="dynamicMenuItems" :current-slug="linksDepartment"/>
      </div>
      <div class="general-info__column">
        <div class="general-info__title">
          <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">Общие сведения</h1>
        </div>
        <div class="general-info__information">
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Полное наименование учреждения:</p>
            </div>
            <p class="text-circe-16">Краевое государственное бюджетное учреждение здравоохранения «Алтайский краевой клинический перинатальный центр»</p>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Сокращенное наименование учреждения:</p>
            </div>
            <p class="text-circe-16">КГБУЗ «АККПЦ»</p>
          </div>
          <div class="general-info__information-text-row">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Дата государственной регистрации:</p>
            </div>
            <p class="text-circe-16"> 17.06.2016</p>
          </div>
          <div class="general-info__information-text-row">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">ОГРН:</p>
            </div>
            <p class="text-circe-16">1162225078113</p>
          </div>
          <div class="general-info__information-text-row">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">ИНН:</p>
            </div>
            <p class="text-circe-16">2225171626</p>
          </div>
          <div class="general-info__information-text-row">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">КПП:</p>
            </div>
            <p class="text-circe-16">222501001</p>
          </div>
          <div class="general-info__information-text-row">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Адрес сайта:</p>
            </div>
            <p class="text-circe-16"><a href="https://xn--22-6kcp5d.xn--p1ai/" target="_blank" rel="noopener noreferrer">https://дар22.рф/</a></p>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Учредитель:</p>
            </div>
            <p class="text-circe-16">Министерство здравоохранения Алтайского края.Учреждение находится в ведомственном подчинении Министерства здравоохранения Алтайского края и действует в соответствии с законодательством Российской Федерации, законодательством Алтайского края.</p>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Сведения об органах управления</p>
            </div>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Министерство здравоохранения Алтайского края</p>
            </div>
            <p class="text-circe-16">
              Министр: Попов Дмитрий Владимирович <br/>
              Телефон приемной: (3852) 62-77-66 <br/>
              Факс приемной: (3852) 62-80-98 <br/>
              Почтовый адрес: 656031, Алтайский край, г. Барнаул, пр. Красноармейский, 95а <br/>
              Сайт: <a href="http://www.zdravalt.ru" target="_blank" rel="noopener noreferrer">http://www.zdravalt.ru</a> <br/>
              Электронная почта: krayzdrav@zdravalt.ru
            </p>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Правительство Алтайского края</p>
            </div>
            <p class="text-circe-16">
              Губернатор Алтайского края, Председатель Правительства Алтайского края: <br/>
              Виктор Петрович Томенко <br/>
              Телефон приемной: (3852) 36-38-05 <br/>
              Тел. (3852) 36-38-63 <br/>
              Почтовый адрес: 656035, Алтайский край, г. Барнаул, пр. Ленина, 59 <br/>
              Сайт: <a href="http://www.altairegion22.ru" target="_blank" rel="noopener noreferrer">http://www.altairegion22.ru</a> <br/>
              Электронная почта: info@altairegion22.ru
            </p>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Уполномоченный по правам человека в Алтайском крае</p>
            </div>
            <p class="text-circe-16">
              Почтовый адрес: 656056, Барнаул, Партизанская, 69 <br/>
              Тел. (3852) 66-71-00 <br/>
              Сайт: <a href="http://protmen.ru/" target="_blank" rel="noopener noreferrer">http://protmen.ru/</a>
            </p>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Уполномоченный при губернаторе Алтайского края по правам ребенка</p>
            </div>
            <p class="text-circe-16">
              Почтовый адрес: 656035, проспект Ленина, 59 <br/>
              Тел. (3852) 29-51-60, 29-51-26 <br/>
              Электронная почта: deti@alregn.ru
            </p>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Территориальный орган Федеральной службы по надзору в сфере здравоохранения и социального развития по Алтайскому краю (Управление Росздравнадзора по Алтайскому краю)</p>
            </div>
            <p class="text-circe-16">
              Руководитель: Зайцев Виктор Иванович <br/>
              Почтовый адрес: 656038, г. Барнаул, пр. Комсомольский, 118 <br/>
              Тел: (3852) 40-35-03 <br/>
              Электронная почта: office@reg22.roszdravnadzor.gov.ru <br/>
              Сайт: <a href="http://22reg.roszdravnadzor.gov.ru" target="_blank" rel="noopener noreferrer">http://22reg.roszdravnadzor.gov.ru</a>
            </p>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Управление Федеральной службы по надзору в сфере защиты прав потребителей и благополучия человека по Алтайскому краю (Управление Роспотребнадзора по Алтайскому краю)</p>
            </div>
            <p class="text-circe-16">
              Руководитель: Пащенко Ирина Геннадьевна <br/>
              Почтовый адрес: 656056, г. Барнаул, ул. Максима Горького, д. 28 <br/>
              Тел: (3852) 24-29-96, горячая линия: (3852) 66-54-27 <br/>
              Сайт: <a href="http://22.rospotrebnadzor.ru/" target="_blank" rel="noopener noreferrer">http://22.rospotrebnadzor.ru/</a>
            </p>
          </div>
          <div class="general-info__information-text-column">
            <div class="general-info__information-text-title">
              <p class="text-TTDrugs-bold-16">Алтайский краевой фонд обязательного медицинского страхования (ТФОМС)</p>
            </div>
            <p class="text-circe-16">
              АО «Алтайский краевой фонд обязательного медицинского страхования» <br/>
              Почтовый адрес: 656043, Алтайский край, г. Барнаул, ул. Молодёжная, 95 <br/>
              Тел.: (3852) 36-06-36 <br/>
              Сайт: <a href="http://www.altfoms.ru" target="_blank" rel="noopener noreferrer">http://www.altfoms.ru</a>
            </p>
          </div>

        </div>
      </div>
      </div>
    <div class="general-info__information-second-block">
      <div class="general-info__information-text-row">
        <div class="general-info__information-text-title">
          <p class="text-TTDrugs-regular-16"> Краевое государственное бюджетное учреждение здравоохранения «Алтайский краевой клинический перинатальный центр» - <span class="text-TTDrugs-bold-16">некоммерческая организация.</span> </p>
        </div>
      </div>
      <div class="general-info__information-text-row">
        <div class="general-info__information-text-title">
          <p class="text-TTDrugs-bold-16">Главный врач:</p>
        </div>
        <p class="text-circe-16">Молчанова Ирина Владимировна</p>
      </div>
      <div class="general-info__information-text-column">
        <div class="general-info__information-text-title">
          <p class="text-TTDrugs-bold-16">Адрес юридический:</p>
        </div>
        <p class="text-circe-16">656045, Алтайский край, г. Барнаул, ул. Фомина, д. 154</p>
      </div>
      <div class="general-info__information-text-column">
        <div class="general-info__information-text-title">
          <p class="text-TTDrugs-bold-16">Адрес фактический:</p>
        </div>
        <p class="text-circe-16">656045, Алтайский край, г. Барнаул, ул. Фомина, д. 154</p>
      </div>
      <div class="general-info__information-text-column">
        <div class="general-info__information-text-title">
          <p class="text-TTDrugs-bold-16">Адрес почтовый:</p>
        </div>
        <p class="text-circe-16">656045, Алтайский край, г. Барнаул, ул. Фомина, д. 154</p>
      </div>
      <div class="general-info__information-text-column">
        <div class="general-info__information-text-title">
          <p class="text-TTDrugs-bold-16">Email:</p>
        </div>
        <p class="text-circe-16">akkpc@zdravalt.ru</p>
      </div>
      <div class="general-info__information-text-column">
        <div class="general-info__information-text-title">
          <p class="text-TTDrugs-bold-16">Справочная:</p>
        </div>
        <p class="text-circe-16">8 (3852) 591-130</p>
      </div>
      <div class="general-info__information-text-column">
        <div class="general-info__information-text-title">
          <p class="text-TTDrugs-bold-16">Сайт:</p>
        </div>
        <p class="text-circe-16"><a href="https://дар22.рф" target="_blank" rel="noopener noreferrer">дар22.рф</a></p>
      </div>
      <div class="general-info__information-text-column">
        <div class="general-info__information-text-title">
          <p class="text-TTDrugs-bold-16">Обособленные структурные подразделения:</p>
        </div>
        <p class="text-circe-16">659323, Алтайский край, г. Бийск, ул. Садовая, д. 210. тел.: 8 (3854) 37-57-02 <br/> 658213 Алтайский край, г. Рубцовск, Ленина проспект, д. 13 тел.: 8 (3855) 79-62-07 <br/> 658823, Алтайский край, г. Славгород, с. Славгородское, ул. Ленина, д. 288<br/>
        </p>
      </div>
    </div>
    <div class="general-info__schedule">

      <AppScheduleTable/>
    </div>
  </div>
</div>

</template>
<script>
import AppScheduleTable from '@/components/ScheduleTable.vue'
import DynamicMenu from "@/components/DynamicMenu.vue";
import menuItemsApi from "@/api/menuItems";

export default {
    name: "AppGeneralInfo",
    components: {DynamicMenu, AppScheduleTable},
    metaInfo() {
      return {
        title: 'Общие сведения | Алтайский краевой клинический перинатальный центр ДАР',
        meta: [
          {
            name: 'description',
            content: 'Общие сведения. Подробная информация о Алтайском краевом клиническом перинатальном центре ДАР.'
          },
          {
            name: 'keywords',
            content: 'Алтайский краевой клинический перинатальный центр'
          }
        ]
      };
    },
    data() {
      return {
        dynamicMenuItems: [],
        linksDepartment: 'about/general-info',
      }
    },
    computed: {
      showDynamicMenu() {
        return this.dynamicMenuItems && this.dynamicMenuItems.length > 0;
      }
    },
    methods: {
      async loadSiblingsForMenu() {
        try {
          const response = await menuItemsApi.getSiblingsByTo('/about/general-info');

          if (response.data.status === "SUCCESS") {
            this.dynamicMenuItems = response.data.result
                .map(item => {
                  const slug = item.to.startsWith('/') ? item.to.substring(1) : item.to;

                  return {
                    text: item.label,
                    link: item.to,
                    slug: slug,
                    active: slug === this.currentPath,
                    id: item.id,
                    order: item.order || 0
                  };
                })
                .sort((a, b) => (a.order || 0) - (b.order || 0));
          }
        } catch (error) {
          console.error('Ошибка при загрузке меню:', error);
        }
      }
    },
    mounted() {
      this.loadSiblingsForMenu();
    }
  };
</script>
